<template>

<a href="https://stripe.com" target="_blank" class="stripe-logo"><span>Powered by Stripe</span></a>

</template>

<script>

export default {

}

</script>

<style scoped>

.stripe-logo {
	display: block;
	margin: 0px auto;
	background-image: url(~@/assets/stripe.logo.png);
	width: 119px;
	height: 26px;
	margin-top: 40px;
}

.stripe-logo span {
	display: none;
}

</style>